import { forwardRef } from "react";
import { usePopoverLegacyContext } from "./usePopoverLegacyContext";
import { Button, ButtonProps } from "../Button";
import { useMergeRefs } from "../../hooks";

export type PopoverLegacyButtonProps = ButtonProps;

export const PopoverLegacyButton = forwardRef<
  HTMLButtonElement,
  PopoverLegacyButtonProps
>(function PopoverButton(props, ref) {
  const { children, size, ...rest } = props;
  const context = usePopoverLegacyContext();
  const childrenRef = (children as any)?.ref;
  const mergedRef = useMergeRefs([context.refs.setReference, ref, childrenRef]);

  return (
    <Button
      ref={mergedRef}
      size={size}
      data-state={context.open ? "open" : "closed"}
      data-anv="popover-button"
      {...context.getReferenceProps(rest)}
    >
      {children}
    </Button>
  );
});
